<!-- <input type="file" id="passport" (change)="onFileSelected($event)" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" /> -->
<ng-container>
  <div class="step" [ngClass]="{'completed': isFileSelected()}">
    <div class="step-content">
      <h4>{{ pickerLabel }}</h4>
      <p *ngIf="isFileSelected()">✅ <strong>{{ fileName }}</strong></p>
    </div>
    <div>
      <button *ngIf="!isFileSelected()" mat-raised-button type="button" color="primary" (click)="fileInput.click()">
        <mat-icon>upload_file</mat-icon>
        Subir
      </button>
      <button *ngIf="isFileSelected()" mat-raised-button type="button" color="primary" (click)="fileInput.click()">
        <mat-icon>upload_file</mat-icon>
      </button>
    </div>
    <!-- Hidden Native Input -->
  <input #fileInput type="file" [accept]="formatsAccepted" (change)="handleFileSelection($event)" hidden />
  </div>
</ng-container>